import { Stack, usePathname } from 'expo-router';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { useDeeplinksFlowExperiment } from 'experiments/deeplinks-flow-feature/use-deeplinks-flow-experiment';
import { useIsNativeTabBarEnabled } from 'hooks/use-is-native-tab-bar-enabled';
import { usePopToTopOnTabSwitch } from 'navigation/hooks/use-pop-to-top-on-tab-switch';
import { isOfferItemRoute } from 'navigation/routing/utils';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants';
import { routes } from 'utils/routing';

export default function OffersLayout() {
  const isNativeTabBarEnabled = useIsNativeTabBarEnabled();
  const {
    isEnabled: isDeeplinksFlowEnabled,
    isLoading: isExperimentLoading,
  } = useDeeplinksFlowExperiment();
  const pathname = usePathname();
  const requireStore =
    Boolean(useFlag(LaunchDarklyFlag.FORCE_RESTAURANT_SELECTION_FOR_REWARDS)) &&
    !(isOfferItemRoute(pathname) && (isExperimentLoading || isDeeplinksFlowEnabled));

  useStoreRequired(requireStore, undefined, routes.offers);
  usePopToTopOnTabSwitch();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: primitive.$mayoEggWhite },
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          header: () => (
            <StandardMobileHeader useNativeTabsRootSafeAreaInset={isNativeTabBarEnabled} />
          ),
          headerShown: true,
        }}
      />
      {/* NOTE: modals are in (modals) */}
    </Stack>
  );
}
